// removed by extract-text-webpack-plugin
module.exports = {"container":"U0E1JqthwTHOXB2NcnOOe","mainSquare":"_12zil0Arl23KY4t0oROPOT","spin":"A9pMJsRp2Q6M8HtAYP2nM","smallSquare":"_3KZYTrf-4j0B_Jc9bRWfOm","square1":"qjc0MBTP_bncmz-7rr4dL _3KZYTrf-4j0B_Jc9bRWfOm","shrink1":"_3DGb4HxrG-xW9OEGU4omML","square2":"_3OrmxmAKQOTcdqwzncfqFH _3KZYTrf-4j0B_Jc9bRWfOm","shrink2":"_2WgT4Aua7zw_DelsTdk-qs","square3":"_2vv2rAeuBx6aQa2gLm9ZD_ _3KZYTrf-4j0B_Jc9bRWfOm","shrink3":"_3H8CXnMbAGiOT8vNB3e46e","square4":"_1lwIx9pJdBaBt3JFRKGzzv _3KZYTrf-4j0B_Jc9bRWfOm","shrink4":"_2Zm0XIAH68q5LQ1XXFNXt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/style.css
// module id = 276
// module chunks = 0